import React from 'react';
import FlippexLoader from '../components/ui/FlippexLoader';

const SIZES = [24, 32, 48, 64, 96];

const Row = ({ bg, label, testId }) => (
  <div className="rounded-2xl border border-black/[0.06] overflow-hidden" data-testid={testId}>
    <div className="px-5 py-3 border-b border-black/[0.06] bg-white">
      <p className="text-[11px] uppercase tracking-[0.16em] text-foreground-muted">{label}</p>
    </div>
    <div className={`${bg} px-5 py-10 flex items-end justify-center gap-10 flex-wrap`}>
      {SIZES.map((size) => (
        <div key={size} className="flex flex-col items-center gap-3">
          <div className="flex items-center justify-center" style={{ width: size, height: size }}>
            <FlippexLoader size={size} />
          </div>
          <span className="text-[11px] text-foreground-muted tabular-nums">{size}px</span>
        </div>
      ))}
    </div>
  </div>
);

export default function LoaderPreviewPage() {
  return (
    <div className="min-h-screen bg-[rgb(var(--background))] px-5 py-16 md:px-10">
      <div className="max-w-4xl mx-auto">
        <p className="text-[11px] uppercase tracking-[0.16em] text-foreground-muted">Internal</p>
        <h1 className="text-3xl md:text-4xl font-heading mt-2">FlippexLoader</h1>
        <p className="text-sm text-foreground-muted mt-3 max-w-xl leading-relaxed">
          Two circles on the brand geometry, meeting on the diagonal and separating again over two
          seconds. The overlap is masked out of both circles, so whatever sits behind the loader shows
          through it.
        </p>

        <div className="mt-10 space-y-6">
          <Row bg="bg-white" label="On white" testId="loader-preview-white" />
          <Row bg="bg-slate-100" label="On light grey" testId="loader-preview-grey" />
          <Row bg="bg-[rgb(var(--background-subtle))]" label="On background subtle" testId="loader-preview-subtle" />
        </div>

        <div className="mt-6 rounded-2xl border border-black/[0.06] overflow-hidden" data-testid="loader-preview-pattern">
          <div className="px-5 py-3 border-b border-black/[0.06] bg-white">
            <p className="text-[11px] uppercase tracking-[0.16em] text-foreground-muted">
              Over a pattern (proves the overlap is transparent)
            </p>
          </div>
          <div
            className="px-5 py-10 flex items-center justify-center"
            style={{
              backgroundImage:
                'repeating-linear-gradient(45deg, rgba(0,0,0,0.06) 0 8px, rgba(0,0,0,0) 8px 16px)',
            }}
          >
            <FlippexLoader size={96} />
          </div>
        </div>
      </div>
    </div>
  );
}
